export const translations = {
  es: {
    // Navbar
    home: 'Inicio',
    watchlist: 'Mi Lista',
    profile: 'Perfil',
    
    // Home
    discover: 'Descubre y Califica Películas',
    discoverSubtitle: 'Encuentra tus películas favoritas y comparte tus opiniones',
    searchPlaceholder: 'Busca una película...',
    search: 'Buscar',
    searching: 'Buscando...',
    resultsFound: 'resultado encontrado',
    resultsFoundPlural: 'resultados encontrados',
    noResults: 'No se encontraron películas para',
    welcomeMessage: '👆 Busca una película para comenzar',
    loadingMovies: 'Cargando películas...',
    trendingMovies: 'Películas en Tendencia',
    errorLoadingMovies: 'No se pudieron cargar las películas. Verifica tu API key.',
    
    // Watchlist
    myWatchlist: 'Mi Lista de Seguimiento',
    moviesSaved: 'película guardada',
    moviesSavedPlural: 'películas guardadas',
    loadingList: 'Cargando tu lista...',
    emptyList: 'Tu lista está vacía',
    emptyListText: 'Agrega películas a tu lista desde la página de inicio haciendo clic en cualquier película',
    removeFromList: 'Eliminar de la lista',
    loginRequiredWatchlist: 'Debes iniciar sesión para ver tu lista de seguimiento',
    
    // My Ratings
    myRatings: 'Mis Calificaciones',
    moviesRated: 'película calificada',
    moviesRatedPlural: 'películas calificadas',
    loadingRatings: 'Cargando tus calificaciones...',
    emptyRatings: 'Aún no has calificado películas',
    emptyRatingsText: 'Cuando califiques películas desde la página de inicio, aparecerán aquí para que no pierdas el seguimiento.',
    loginRequiredRatings: 'Debes iniciar sesión para ver tus calificaciones',
    yourRating: 'Tu calificación',
    errorLoadingRatings: 'Error al cargar tus calificaciones',
    
    // Profile
    myProfile: 'Mi Perfil',
    personalInfo: 'Información Personal',
    email: 'Email',
    emailHint: 'El email no se puede modificar',
    username: 'Nombre de Usuario',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    profileUpdated: 'Perfil actualizado exitosamente',
    preferences: 'Preferencias',
    notifications: 'Notificaciones',
    notificationsDesc: 'Recibir notificaciones por email',
    language: 'Idioma',
    languageDesc: 'Idioma de la interfaz',
    theme: 'Tema',
    themeDesc: 'Apariencia de la aplicación',
    dark: 'Oscuro',
    light: 'Claro',
    session: 'Sesión',
    logout: 'Cerrar Sesión',
    
    // Movie Modal
    rateMovie: 'Califica esta película (1-5 estrellas):',
    selectRating: 'Selecciona una calificación',
    review: 'Reseña (opcional):',
    reviewPlaceholder: 'Escribe tu opinión sobre esta película...',
    saveReview: 'Guardar Reseña',
    savingReview: 'Guardando...',
    reviewSaved: '¡Reseña guardada exitosamente!',
    addToList: '+ Agregar a Lista',
    inList: '✓ En Lista',
    synopsis: 'Sinopsis',
    minutes: 'minutos',
    votes: 'votos',
    
    // Auth
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    noAccount: '¿No tienes cuenta?',
    haveAccount: '¿Ya tienes cuenta?',
    signUp: 'Regístrate',
    signIn: 'Inicia sesión',
    verifyEmail: 'Verifica tu correo electrónico',
    emailSent: 'Hemos enviado un enlace de confirmación a',
    checkSpam: 'Importante: Si no encuentras el correo, revisa tu carpeta de spam o correo no deseado',
    confirmAccount: 'Una vez que confirmes tu cuenta, podrás iniciar sesión normalmente',
    password: 'Contraseña',
    passwordPlaceholder: '••••••••',
    loginSuccess: '¡Inicio de sesión exitoso!',
    registerSuccess: '¡Registro exitoso!',
    forgotPassword: '¿Olvidaste tu contraseña?',
    recoverPassword: 'Recuperar contraseña',
    backToLogin: '← Volver al inicio de sesión',
    forgotPasswordHint: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.',
    sendLink: 'Enviar enlace',
    emailVerificationNotice: 'Verifica tu correo electrónico',
    emailVerificationSent: 'Hemos enviado un enlace de confirmación a',
    emailVerificationSpam: 'Importante: Si no encuentras el correo, revisa tu carpeta de spam o correo no deseado',
    emailVerificationConfirm: 'Una vez que confirmes tu cuenta, podrás iniciar sesión normalmente.',
    emailAlreadyExists: 'Ya existe una cuenta con este correo. Ve a Iniciar sesión.',
    emailResetSent: 'Revisa tu correo: te enviamos un enlace para restablecer tu contraseña. Si no lo ves, revisa la carpeta de spam.',
    showPassword: 'Ver contraseña',
    hidePassword: 'Ocultar contraseña',
    usernamePlaceholder: 'Tu nombre de usuario',
    emailPlaceholder: 'tu@email.com',
    
    // Reset Password
    newPassword: 'Nueva contraseña',
    newPasswordTitle: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordMismatch: 'Las contraseñas no coinciden.',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres.',
    passwordUpdated: 'Contraseña actualizada',
    passwordUpdatedMessage: 'Ya puedes iniciar sesión con tu nueva contraseña. Redirigiendo...',
    savePassword: 'Guardar contraseña',
    checkingLink: 'Comprobando enlace...',
    invalidLink: 'Enlace no válido o expirado',
    invalidLinkMessage: 'Solicita un nuevo enlace desde la pantalla de inicio de sesión con «¿Olvidaste tu contraseña?».',
    goToLogin: 'Ir al inicio de sesión',
    backToHome: '← Volver al inicio',
    chooseSecurePassword: 'Elige una contraseña segura para tu cuenta.',
    minCharacters: 'Mínimo 6 caracteres',
    repeatPassword: 'Repite la contraseña',
    
    // Confirmation
    thankYouConfirm: '¡Gracias por confirmar tu cuenta!',
    accountVerified: 'Tu cuenta ha sido verificada exitosamente. Ahora eres parte de',
    verifyingAccount: 'Verificando tu cuenta...',
    startExploring: 'Comenzar a explorar',
    featureRate: 'Califica tus películas favoritas',
    featureRecommendations: 'Recibe recomendaciones personalizadas',
    featureWatchlist: 'Crea y gestiona tu lista de películas',
    alreadyLoggedIn: 'Ya puedes iniciar sesión y empezar a usar todas las funciones.',
    notLoggedInYet: 'Si aún no has iniciado sesión, hazlo ahora para comenzar.',
    
    // Recommendations
    recommendations: 'Recomendaciones',
    recommendationsSubtitle: 'Basado en las {count} películas de tu lista',
    recommendationsEmptySubtitle: 'Agrega películas a tu lista para obtener recomendaciones personalizadas',
    refreshRecommendations: 'Actualizar Recomendaciones',
    loading: 'Cargando...',
    loadingRecommendations: 'Analizando tu lista y generando recomendaciones...',
    loginRequired: 'Debes iniciar sesión para ver recomendaciones',
    basedOnYourWatchlist: 'Basadas en tu Lista',
    similarMovies: 'Películas Similares',
    popularInYourGenres: 'Populares en tus Géneros',
    noRecommendations: 'No hay recomendaciones disponibles en este momento',
    noSimilarMovies: 'No se encontraron películas similares',
    noPopularMovies: 'No hay películas populares disponibles',
    emptyWatchlistTitle: 'Tu lista está vacía',
    emptyWatchlistText: 'Agrega películas a tu lista para recibir recomendaciones personalizadas',
    
    // App Header
    appTitle: 'Rate by Recommendation',
    appSubtitle: 'Inicia sesión para comenzar',
    
    // Circles
    circles: 'Círculos',
    myCircles: 'Mis Círculos',
    circlesSubtitle: 'Crea círculos para compartir tus recomendaciones con amigos y familia.',
    createGroup: 'Crear grupo',
    loadingCircles: 'Cargando círculos...',
    noCircles: 'Aún no tienes círculos',
    noCirclesText: 'Crea tu primer círculo para empezar a compartir recomendaciones con tus amigos y familia.',
    createNewCircle: 'Crear nuevo círculo',
    editCircle: 'Editar círculo',
    circleName: 'Nombre del círculo',
    circleNamePlaceholder: 'Familia, Amigos cinéfilos, Compañeros de trabajo...',
    circleDescription: 'Descripción (opcional)',
    circleDescriptionPlaceholder: 'Describe brevemente el propósito del círculo.',
    createCircle: 'Crear círculo',
    creating: 'Creando...',
    cancel: 'Cancelar',
    deleteCircle: 'Eliminar círculo',
    deleteCircleConfirm: '¿Estás seguro de que quieres eliminar el círculo',
    deleteCircleWarning: 'Esta acción no se puede deshacer. Se eliminarán todas las recomendaciones compartidas en este círculo.',
    deleteCircleButton: 'Eliminar círculo',
    deleting: 'Eliminando...',
    invitationLink: 'Link de invitación:',
    shareInviteLink: 'Comparte este link para que otras personas se unan a tu círculo.',
    viewRecommendations: 'Ver recomendaciones',
    backToCircles: '← Volver a Mis Círculos',
    circleRecommendations: 'película recomendada',
    circleRecommendationsPlural: 'películas recomendadas',
    noCircleRecommendations: 'Aún no hay recomendaciones',
    noCircleRecommendationsText: 'Cuando los miembros del círculo compartan sus reseñas, aparecerán aquí.',
    viewMembers: 'Ver miembros',
    circleMembers: 'Miembros del círculo',
    noMembers: 'No hay miembros en este círculo.',
    member: 'Miembro',
    creator: 'Creador',
    removeMember: 'Eliminar miembro',
    shareInCircles: 'Compartir en tus círculos',
    shareInCirclesSubtitle: 'Elige en qué círculos quieres que tus amigos vean esta reseña.',
    shareReview: 'Compartir reseña en círculos',
    sharing: 'Compartiendo...',
    reviewShared: 'Reseña compartida con tu(s) círculo(s).',
    joinCircle: 'Uniéndote al círculo',
    joiningCircle: 'Te uniste al círculo',
    redirecting: 'Redirigiendo...',
    circleNotFound: 'No se encontró ningún círculo con este enlace.',
    joinError: 'No se pudo completar la unión al círculo. Intenta de nuevo más tarde.',
    recommendedBy: 'Recomendado por:',
    rating: 'Calificación:',
    errorLoadingCircles: 'No se pudieron cargar tus círculos.',
    errorCreatingCircle: 'No se pudo crear el círculo. Intenta de nuevo.',
    errorEditingCircle: 'No se pudo editar el círculo. Intenta de nuevo.',
    errorDeletingCircle: 'No se pudo eliminar el círculo. Intenta de nuevo.',
    errorLoadingRecommendations: 'No se pudieron cargar las recomendaciones del círculo.',
    errorRemovingMember: 'No se pudo eliminar el miembro. Intenta de nuevo.',
    circleNameRequired: 'El nombre del círculo es obligatorio.',
    mustLoginToJoin: 'Debes iniciar sesión para unirte a un círculo.',
    supabaseNotConfigured: 'Supabase no está configurado.',
  },
  en: {
    // Navbar
    home: 'Home',
    watchlist: 'My List',
    profile: 'Profile',
    
    // Home
    discover: 'Discover and Rate Movies',
    discoverSubtitle: 'Find your favorite movies and share your opinions',
    searchPlaceholder: 'Search for a movie...',
    search: 'Search',
    searching: 'Searching...',
    resultsFound: 'result found',
    resultsFoundPlural: 'results found',
    noResults: 'No movies found for',
    welcomeMessage: '👆 Search for a movie to get started',
    loadingMovies: 'Loading movies...',
    trendingMovies: 'Trending Movies',
    errorLoadingMovies: 'Could not load movies. Please check your API key.',
    
    // Watchlist
    myWatchlist: 'My Watchlist',
    moviesSaved: 'movie saved',
    moviesSavedPlural: 'movies saved',
    loadingList: 'Loading your list...',
    emptyList: 'Your list is empty',
    emptyListText: 'Add movies to your list from the home page by clicking on any movie',
    removeFromList: 'Remove from list',
    loginRequiredWatchlist: 'You must be logged in to view your watchlist',
    
    // My Ratings
    myRatings: 'My Ratings',
    moviesRated: 'movie rated',
    moviesRatedPlural: 'movies rated',
    loadingRatings: 'Loading your ratings...',
    emptyRatings: "You haven't rated any movies yet",
    emptyRatingsText: 'When you rate movies from the home page, they will appear here so you can keep track.',
    loginRequiredRatings: 'You must be logged in to view your ratings',
    yourRating: 'Your rating',
    errorLoadingRatings: 'Error loading your ratings',
    
    // Profile
    myProfile: 'My Profile',
    personalInfo: 'Personal Information',
    email: 'Email',
    emailHint: 'Email cannot be modified',
    username: 'Username',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    profileUpdated: 'Profile updated successfully',
    preferences: 'Preferences',
    notifications: 'Notifications',
    notificationsDesc: 'Receive email notifications',
    language: 'Language',
    languageDesc: 'Interface language',
    theme: 'Theme',
    themeDesc: 'Application appearance',
    dark: 'Dark',
    light: 'Light',
    session: 'Session',
    logout: 'Log Out',
    
    // Movie Modal
    rateMovie: 'Rate this movie (1-5 stars):',
    selectRating: 'Select a rating',
    review: 'Review (optional):',
    reviewPlaceholder: 'Write your opinion about this movie...',
    saveReview: 'Save Review',
    savingReview: 'Saving...',
    reviewSaved: 'Review saved successfully!',
    addToList: '+ Add to List',
    inList: '✓ In List',
    synopsis: 'Synopsis',
    minutes: 'minutes',
    votes: 'votes',
    
    // Auth
    login: 'Sign In',
    register: 'Sign Up',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    verifyEmail: 'Verify your email',
    emailSent: 'We have sent a confirmation link to',
    checkSpam: 'Important: If you cannot find the email, check your spam or junk folder',
    confirmAccount: 'Once you confirm your account, you will be able to sign in normally',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    loginSuccess: 'Login successful!',
    registerSuccess: 'Registration successful!',
    forgotPassword: 'Forgot your password?',
    recoverPassword: 'Recover password',
    backToLogin: '← Back to login',
    forgotPasswordHint: 'Enter your email and we will send you a link to reset your password.',
    sendLink: 'Send link',
    emailVerificationNotice: 'Verify your email',
    emailVerificationSent: 'We have sent a confirmation link to',
    emailVerificationSpam: 'Important: If you cannot find the email, check your spam or junk folder',
    emailVerificationConfirm: 'Once you confirm your account, you will be able to sign in normally.',
    emailAlreadyExists: 'An account with this email already exists. Go to Sign In.',
    emailResetSent: 'Check your email: we sent you a link to reset your password. If you don\'t see it, check your spam folder.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    usernamePlaceholder: 'Your username',
    emailPlaceholder: 'your@email.com',
    
    // Reset Password
    newPassword: 'New password',
    newPasswordTitle: 'New password',
    confirmPassword: 'Confirm password',
    passwordMismatch: 'Passwords do not match.',
    passwordMinLength: 'Password must be at least 6 characters.',
    passwordUpdated: 'Password updated',
    passwordUpdatedMessage: 'You can now sign in with your new password. Redirecting...',
    savePassword: 'Save password',
    checkingLink: 'Checking link...',
    invalidLink: 'Invalid or expired link',
    invalidLinkMessage: 'Request a new link from the login screen with "Forgot your password?".',
    goToLogin: 'Go to login',
    backToHome: '← Back to home',
    chooseSecurePassword: 'Choose a secure password for your account.',
    minCharacters: 'Minimum 6 characters',
    repeatPassword: 'Repeat password',
    
    // Confirmation
    thankYouConfirm: 'Thank you for confirming your account!',
    accountVerified: 'Your account has been successfully verified. You are now part of',
    verifyingAccount: 'Verifying your account...',
    startExploring: 'Start exploring',
    featureRate: 'Rate your favorite movies',
    featureRecommendations: 'Get personalized recommendations',
    featureWatchlist: 'Create and manage your movie list',
    alreadyLoggedIn: 'You can now sign in and start using all features.',
    notLoggedInYet: 'If you haven\'t signed in yet, do it now to get started.',
    
    // Recommendations
    recommendations: 'Recommendations',
    recommendationsSubtitle: 'Based on the {count} movies in your list',
    recommendationsEmptySubtitle: 'Add movies to your list to get personalized recommendations',
    refreshRecommendations: 'Refresh Recommendations',
    loading: 'Loading...',
    loadingRecommendations: 'Analyzing your list and generating recommendations...',
    loginRequired: 'You must be logged in to see recommendations',
    basedOnYourWatchlist: 'Based on Your List',
    similarMovies: 'Similar Movies',
    popularInYourGenres: 'Popular in Your Genres',
    noRecommendations: 'No recommendations available at this time',
    noSimilarMovies: 'No similar movies found',
    noPopularMovies: 'No popular movies available',
    emptyWatchlistTitle: 'Your list is empty',
    emptyWatchlistText: 'Add movies to your list to receive personalized recommendations',
    
    // App Header
    appTitle: 'Rate by Recommendation',
    appSubtitle: 'Sign in to get started',
    
    // Circles
    circles: 'Circles',
    myCircles: 'My Circles',
    circlesSubtitle: 'Create circles to share your recommendations with friends and family.',
    createGroup: 'Create group',
    loadingCircles: 'Loading circles...',
    noCircles: "You don't have any circles yet",
    noCirclesText: 'Create your first circle to start sharing recommendations with your friends and family.',
    createNewCircle: 'Create new circle',
    editCircle: 'Edit circle',
    circleName: 'Circle name',
    circleNamePlaceholder: 'Family, Cinephile friends, Coworkers...',
    circleDescription: 'Description (optional)',
    circleDescriptionPlaceholder: 'Briefly describe the purpose of the circle.',
    createCircle: 'Create circle',
    creating: 'Creating...',
    cancel: 'Cancel',
    deleteCircle: 'Delete circle',
    deleteCircleConfirm: 'Are you sure you want to delete the circle',
    deleteCircleWarning: 'This action cannot be undone. All shared recommendations in this circle will be deleted.',
    deleteCircleButton: 'Delete circle',
    deleting: 'Deleting...',
    invitationLink: 'Invitation link:',
    shareInviteLink: 'Share this link so that other people can join your circle.',
    viewRecommendations: 'View recommendations',
    backToCircles: '← Back to My Circles',
    circleRecommendations: 'movie recommended',
    circleRecommendationsPlural: 'movies recommended',
    noCircleRecommendations: 'No recommendations yet',
    noCircleRecommendationsText: 'When circle members share their reviews, they will appear here.',
    viewMembers: 'View members',
    circleMembers: 'Circle members',
    noMembers: 'There are no members in this circle.',
    member: 'Member',
    creator: 'Creator',
    removeMember: 'Remove member',
    shareInCircles: 'Share in your circles',
    shareInCirclesSubtitle: 'Choose which circles you want your friends to see this review in.',
    shareReview: 'Share review in circles',
    sharing: 'Sharing...',
    reviewShared: 'Review shared with your circle(s).',
    joinCircle: 'Joining circle',
    joiningCircle: 'You joined the circle',
    redirecting: 'Redirecting...',
    circleNotFound: 'No circle found with this link.',
    joinError: 'Could not complete joining the circle. Please try again later.',
    recommendedBy: 'Recommended by:',
    rating: 'Rating:',
    errorLoadingCircles: 'Could not load your circles.',
    errorCreatingCircle: 'Could not create the circle. Please try again.',
    errorEditingCircle: 'Could not edit the circle. Please try again.',
    errorDeletingCircle: 'Could not delete the circle. Please try again.',
    errorLoadingRecommendations: 'Could not load circle recommendations.',
    errorRemovingMember: 'Could not remove member. Please try again.',
    circleNameRequired: 'Circle name is required.',
    mustLoginToJoin: 'You must be logged in to join a circle.',
    supabaseNotConfigured: 'Supabase is not configured.',
  },
};

export const useTranslation = (language = 'es') => {
  return (key) => {
    return translations[language]?.[key] || translations.es[key] || key;
  };
};

